var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "liquidez", attrs: { fluid: "" } },
    [
      _c("DataTable", {
        attrs: {
          loading: _vm.loading,
          emErro: _vm.emErro,
          errorMessage: _vm.errorMessage,
          calculos: _vm.calculos.collection
        }
      }),
      _c("v-card", { staticClass: "card" }, [
        _c("div", { staticClass: "title" }),
        _c(
          "div",
          { staticClass: "grafico" },
          [
            _c("Bar", {
              staticClass: "grafico-teste",
              attrs: {
                dates: _vm.dates,
                chartData: _vm.arrTeste,
                chartData2: _vm.arrTeste2,
                options: _vm.options,
                plugins: _vm.plugins,
                colors: _vm.colors,
                label: "Rentabilidade acumulada",
                label2: "Rentabilidade mensal"
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }